module.exports = __webpack_public_path__ + "static/yukiko-yoshida-3ecbb89a892ca173f636e9c477a35d6b.jpg";